/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Rukumberi 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
module.exports = {
  "Gituza": ["Gitesanyi", "Gituza", "Mfune", "Ruyenzi"],
  "Ntovi": ["Iyantende", "Kigese", "Mugwato", "Ntovi", "Rukumberi", "Rwamibabi"],
  "Rubago": ["Akabungo", "Kavumve", "Nyagakizi", "Nyagitabire", "Rubago"],
  "Rubona": ["Kagarama", "Maswa I", "Maswa II", "Rugenda I", "Rugenda II", "Ruyenzi I"],
  "Rwintashya": ["Bare", "Karokora", "Rwimpongo I", "Rwimpongo II", "Shyembe"]
};